// Shared Framer Motion variant presets — single source of truth for the app's
// entrance + dialog choreography. Consumers gate the `initial` prop with
// useReducedMotion() from motion/react so motion is skipped when the OS asks.
import type { Variants, Transition } from 'motion/react';

export const spring: Transition = { type: 'spring', stiffness: 380, damping: 30 };

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 8 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.22, ease: 'easeOut' } },
};

export const staggerContainer: Variants = {
  hidden: {},
  show:   { transition: { staggerChildren: 0.045 } },
};

export const staggerItem: Variants = {
  hidden: { opacity: 0, y: 10 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.25, ease: 'easeOut' } },
};

export const dialogPop: Variants = {
  hidden: { opacity: 0, scale: 0.96, y: 6 },
  show:   { opacity: 1, scale: 1, y: 0, transition: { duration: 0.18, ease: 'easeOut' } },
  exit:   { opacity: 0, scale: 0.97, y: 4, transition: { duration: 0.12 } },
};
